exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.self-rating-grade-wrap .weui-toast {\r\n  padding: 0.9rem 0;\n}\r\n", ""]);

// exports
